// import 'babel-polyfill'
import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import md5 from "js-md5";
Vue.use(Vuex);
var root = process.env.API_ROOT;
const state = {
  userCount: "",
  webCount: {
    base_conf: {
      is_home_search: 0,
      is_user_name: 0,
      is_banner: 0,
      is_fudou: 0,
      is_nav: 0
    }
  },
  username: "",
  test: null,
  unitinfo: "", //商城单位（积分比例及单位名称）
  exchangeinfo: "", //兑换平台数据
  account: "",
  address: {
    xq: "北京朝阳区三环以内",
    area: "北京-朝阳区-三环以内",
    province_id: 1,
    city_id: 72,
    country_id: 2799,
    town_id: 0
  },
  closed: 1,
  mallStockShow: false
};
const mutations = {
  exchange(state) {
    var gid = GetQueryString("gid");
    var uid = GetQueryString("uid");
    // var ts = new Date($.ajax({async: false}).getResponseHeader("Date"));
    var ts = new Date();
    ts = new Date(ts).getTime();
    ts = ts / 1000;
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    $.ajax({
      type: "post",
      url: root + "/active/information",
      data: {
        id_active: gid,
        timeStamp: ts,
        apiKey: apiKey,
        sign: sign,
        uid: uid
      },
      success: function(res) {
        if (res.code == "100") {
          state.exchangeinfo = res.data;
          document.title = res.data.name;
          if (res.data.status == 0) {
            // document.title = '积分商城'
            document.getElementById("over").style.display = "block";
            router.push({ path: "/over", query: { gid: gid } });
          }
          if (Date.parse(res.data.effective) / 1000 < ts) {
            // document.title = '积分商城'
            document.getElementById("over").style.display = "block";
            state.exchangeinfo.tourist = 1;
            router.push({ path: "/over", query: { gid: gid } });
          }
        } else {
          router.push({ path: "/over" });
        }
      },
      error: function(err) {}
    });
  },
  webInfo(state) {
    //商城配置
    // var ts = new Date($.ajax({async: false}).getResponseHeader("Date"));
    var ts = new Date();
    ts = new Date(ts).getTime();
    ts = ts / 1000;
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    var str = window.location.host;
    var malltype = str.split(".")[0];
    // var malltype = 'geren';
    var url = root + "/sys/info";

    $.ajax({
      type: "GET",
      // url: root + '/sys/info/domain/xl',//线下调试地址
      url: url, //正式地址
      data: {
        timeStamp: ts,
        apiKey: apiKey,
        sign: sign,
        terminal: "wap",
        domain: malltype
      },
      success: function(res) {
        console.log(res);
        if (res.code == "100") {
          console.log(res.data);
          // localStorage.setItem("webInfo", JSON.stringify(res.data));
          var id = res.data.id_example;
          var closed = res.data.switch_status;
          localStorage.setItem("closed", closed);
          localStorage.setItem("mallid", id); //商城ID
          localStorage.setItem("login_code", res.data.wx_app_id)
          state.webCount = res.data;
          $.ajax({
            //积分单位及比例
            type: "GET",
            url: root + "/sys/point",
            data: {
              id_example: id,
              timeStamp: ts,
              apiKey: apiKey,
              sign: sign
            },
            success: function(res) {
              if (res.code == "100") {
                console.log(res.data);
                state.unitinfo = res.data;
                localStorage.setItem("point", res.data.back_item);
                localStorage.setItem("unit", res.data.name);
              } else {
              }
            },
            error: function(err) {}
          });
        } else if (JSON.parse(res).code == "-500") {
          document.getElementById("timerror").style.display = "block";
        } else {
          document.getElementById("error").style.display = "block";
        }
      },
      error: function(err) {}
    });
  },
  userInfo(state) {
    //个人信息
    var isUser = localStorage.getItem("BLHuser");
    var mallid = localStorage.getItem("mallid");
    // var ts = new Date($.ajax({async: false}).getResponseHeader("Date"));
    var ts = new Date();
    ts = new Date(ts).getTime();
    ts = ts / 1000;
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    $.ajax({
      type: "post",
      url: root + "/user/user/info",
      data: {
        id_example: mallid,
        token_user: isUser,
        timeStamp: ts,
        apiKey: apiKey,
        sign: sign
      },
      success: function(res) {
        if (res.code == "100") {
          localStorage.setItem("total", res.data.point); //我能兑换
          localStorage.setItem("user_id", res.data.user_id);
          state.userCount = res.data;
          var name = res.data.account;
          localStorage.setItem('isResetting', res.data.is_reset_password)
          if (name.length > 6) {
            state.username =
              name.substr(0, 2) + "****" + name.substr(name.length - 2);
          } else {
            state.username = name.substr(0, 2) + "****";
          }
        } else {
          state.userCount = "";
          localStorage.setItem('isResetting', 0)
        }
      },
      error: function(err) {}
    });
  },
  wapinfo() {
    var isUser = localStorage.getItem("BLHuser");
    var mallid = localStorage.getItem("mallid");
    // var ts = new Date($.ajax({async: false}).getResponseHeader("Date"));
    var ts = new Date();
    ts = new Date(ts).getTime();
    ts = ts / 1000;
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    var str = window.location.host;
    var malltype = str.split(".")[0];
    var url = root + "/sys/info"; //正式地址
    $.ajax({
      type: "get",
      // url: root + '/sys/info/domain/xl',//线下调试地址
      url: url,
      data: {
        terminal: "wap",
        token_user: isUser,
        timeStamp: ts,
        apiKey: apiKey,
        sign: sign,
        domain: malltype
      },
      success: function(res) {
        if (res.code == "100") {
          console.log(res.data);
          if (
            res.data.location_url != undefined &&
            res.data.location_url != null
          ) {
            window.location.href = res.data.location_url;
            return false;
          }
          if (res.data.switch_status == 0) {
            //商城关闭
            router.push({ name: "Closed" });
            document.body.removeChild(document.getElementById("Loading"));
            return;
          }
          if (res.data.visitor_status == 0) {
            //游客模式 1为开启 0为关闭
            var isUser = localStorage.getItem("BLHuser");
            if (isUser != null && isUser != undefined && isUser != "") {
            } else {
              router.push({ path: "/login" });
            }
            if (typeof document.getElementById("Loading") == "Node") {
              document.body.removeChild(document.getElementById("Loading"));
            }
          }
        } else {
        }
      },
      error: function(err) {}
    });
  },
  gonggao() {
    var isUser = localStorage.getItem("BLHuser");
    var mallid = localStorage.getItem("mallid");
    // var ts = new Date($.ajax({async: false}).getResponseHeader("Date"));
    var ts = new Date();
    ts = new Date(ts).getTime();
    ts = ts / 1000;
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    $.ajax({
      type: "get",
      url: root + "/sys/maintain",
      data: {
        timeStamp: ts,
        apiKey: apiKey,
        sign: sign,
        id_example: mallid
      },
      success: function(res) {
        if (res.code == "100") {
          if (res.data.status == 1) {
            //商城维护
            router.push({ name: "Maintain" });
            document.body.removeChild(document.getElementById("Loading"));
          }
        } else {
        }
      },
      error: function(err) {}
    });
  },
  setAddress(state, value) {
    var xq = "";
    value.area.split("-").forEach(item => {
      xq = xq + item;
    });
    state.address.xq = xq;
    state.address.area = value.area;
    state.address.city_id = value.city_id;
    state.address.country_id = value.country_id;
    state.address.province_id = value.province_id;
    state.address.town_id = value.town_id;
  },
  setClosed(state, value) {
    console.log("value :>> ", value);
    state.closed = value;
  },
  setMallStock(state, value) {
    console.log("value :>> ", value);
    state.mallStockShow = value;
  }
};
function GetQueryString(name) {
  //获取url
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg); //search,查询？后面的参数，并匹配正则
  if (r != null) return unescape(r[2]);
  return null;
}
export default new Vuex.Store({
  state,
  mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js